<template>
  <v-list>
    <v-subheader>Pliki</v-subheader>

    <v-list-item>
      <v-list-item-icon>
        <!-- <v-icon color="indigo darken-2">mdi-phone</v-icon> -->
        <v-icon>mdi-file-document-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>OWH</v-list-item-title>
        <v-list-item-subtitle>Ogólne Warunki Handlowe</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon href="https://api.flotex.pl/public/owh" target="_blank">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-list-item v-if="showPromotionRules">
      <v-list-item-icon>
        <!-- <v-icon color="indigo darken-2">mdi-phone</v-icon> -->
        <v-icon>mdi-file-document-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>Regulamin</v-list-item-title>
        <v-list-item-subtitle>Polecaj i Tankuj Taniej</v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn
          icon
          href="https://api.flotex.pl/common/Regulamin_Polecaj_i_Tankuj_Taniej.pdf"
          target="_blank"
        >
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <v-list-item>
      <v-list-item-icon>
        <!-- <v-icon color="indigo darken-2">mdi-phone</v-icon> -->
        <v-icon>mdi-file-document-outline</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>Szablon umowy</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon :href="contractTemplateUrl" target="_blank">
          <v-icon>mdi-download</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'BlankPublicFiles',
  computed: {
    // blank: get('blank/data'),
    isFromAuction: get('blank/data@isFromAuction'),
    customerGroupId: get('blank/data@customerGroupId'),
    customerGroupCode: get('blank/data@customerGroupCode'),
    showPromotionRules() {
      // console.log({...this.blank})

      if (
        this.isFromAuction ||
        this.customerGroupId ||
        this.customerGroupCode
      ) {
        return false
      }

      var start = new Date('2021-10-18')
      var finish = new Date('2022-12-31')
      var now = new Date()
      if (now.getTime() < start.getTime()) {
        return false
      }
      if (now.getTime() > finish.getTime()) {
        return false
      }

      return true
    },
    contractTemplateUrl() {
      let url =
        // 'https://portal.flotex.pl/flBlankNewCustomerWizard/getTemplatePDF'
        'https://api.flotex.pl/public/contract-template'
      if (this.showPromotionRules) {
        url += '?promo=true'
      }

      return url
    }
  }
}
</script>
